import { render } from "./App.vue?vue&type=template&id=1bd3d029"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"public/themes/default/resources/app/vue/components/AdvancedSearch/App.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1bd3d029"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1bd3d029', __exports__)) {
    api.reload('1bd3d029', __exports__)
  }
  
  module.hot.accept("./App.vue?vue&type=template&id=1bd3d029", () => {
    api.rerender('1bd3d029', render)
  })

}


export default __exports__